module["exports"] = [
  "######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/postcode.js
// module id = 1719
// module chunks = 0